import { CalendarComponentOptions } from 'ion2-calendar';
import { Ortak } from './../../../providers/ortak';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ModalController, ActionSheetController, Platform  } from 'ionic-angular';
import { HareketdetayPage } from '../hareketdetay/hareketdetay';
import { PerakendeFaturaDetayPage } from '../../faturaislemleri/perakende-fatura-detay/perakende-fatura-detay';
import * as jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';
import { File } from '@ionic-native/file';
declare var cordova: any;
// var pdfMake = require("pdfmake/build/pdfmake");
// var pdfFonts = require("pdfmake/build/vfs_fonts");
// pdfMake.vfs = pdfFonts.pdfMake.vfs;
//  var htmlToPdfmake = require("html-to-pdfmake");
/**
 * Generated class for the CariHareketleriBakiyeBazliPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
 
@Component({
  selector: 'page-cari-hareketleri-bakiye-bazli',
  templateUrl: 'cari-hareketleri-bakiye-bazli.html',
})
export class CariHareketleriBakiyeBazliPage {
  @ViewChild('sideNavUrunAra') sideNav;
  pdfdetaydata=[];
  tarih1: any;
  tarih2: any;
  toplamAlacak:number=0;
  toplamBorc:number=0;
  toplamBakiye:number=0;
  GirisIslemiTutari: number = 0;
  CikisIslemiTutari: number = 0;
  GirisCikisFarki: number = 0;
  KasaHareketleri = [];
  tarihfilteraktifmi: number = 0;
  girishareketlerilistesi = [];
  cikishareketlerilistesi = [];
  chartVar: any;
  gelirgiderSegment: any;
  sol_segment: any;
  KasaListesi = [];
  aranan="";
  vwCari: any = {};
  Cari: any = { ID: "" };
  take:number=100;
  skip:number=0;
  baslangic:any;
  bitis:any;
  kullaniciyetkiseviyesi: any;
  dateRange: {
    from: Date
    to: Date
  } = {
      from: this.tarih1,
      to: this.tarih2
    };
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  optionsRange: CalendarComponentOptions = {
    from: new Date(2016, 1, 1),
    pickMode: 'range',
    color: "primary",
    monthPickerFormat: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Tem", "Agust", "Eylül", "Ekim", "Kasım", "Aralık"]
  };

  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public modalCtrl:ModalController,
    public actionSheetCtrl:ActionSheetController,
    public navParams: NavParams) {
      var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
      var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0,-1);
          this.tarih1 = this.ortak.tarih(this.ortak.storageGunTarihiGetir);
          this.tarih2 = localISOTime;
          if (navParams.get("vwCari") != null) {
            this.vwCari = navParams.get("vwCari");
            var data = new FormData();
            data.append("cari_id", this.vwCari.ID);
            this.bllOrtak.islem(data, "CariGetirByID", "", false).then(a => {
              var Sonuc = <any>a;
              this.Cari = Sonuc.SonucObject;
      
            }
            )
  }
  this.kullaniciyetkiseviyesi = this.ortak.kullaniciType;
}

  ionViewDidLoad() {
    this.dateRange.from = this.ortak.storageGunTarihiGetir;
    this.dateRange.to = this.ortak.storageGunTarihiGetir;
    this.closeNav();
    this.RaporGetirflitresiz();
    this.gelirgiderSegment = "tümü";
    this.kasaListesi();
  }
  openNav() {
    let sideElement = this.sideNav.nativeElement
    sideElement.style.display = "block";
  }
  closeNav() {
    let sideElement = this.sideNav.nativeElement;
    sideElement.style.display = "none";
  }

  generatePdf(){
    const div = document.getElementById("Html2Pdf");
    const options = {background:"white",height :650 , width : 400  };
    // html2canvas(div,options).then((canvas)=>{
      //Initialize JSPDF
      // var doc = new jsPDF("p","mm","a4");
      //Converting canvas to Image
      // let imgData = canvas.toDataURL("image/PNG");
      //Add image Canvas to PDF
      // doc.addImage(imgData, 'PNG', 20,20 );
      
      // let pdfOutput = doc.output();
      // using ArrayBuffer will allow you to put image inside PDF
      // let buffer = new ArrayBuffer(pdfOutput.length);
      // let array = new Uint8Array(buffer);
      // for (var i = 0; i < pdfOutput.length; i++) {
      //     array[i] = pdfOutput.charCodeAt(i);
      // }


      //This is where the PDF file will stored , you can change it as you like
      // for more information please visit https://ionicframework.com/docs/native/file/
      // const directory = this.file.externalApplicationStorageDirectory ;

      // //Name of pdf
      // const fileName = "example.pdf";
      
      // //Writing File to Device
      // // this.file.writeFile(directory,fileName,buffer)
      // .then((success)=> console.log("File created Succesfully" + JSON.stringify(success)))
      // .catch((error)=> console.log("Cannot Create File " +JSON.stringify(error)));
  
  
    // });
  }
  pdfdetaylari(){
    if(this.pdfdetaydata!=null)
      {
        this.generatePdf();
      }
  }
   
  RaporGetir() {
    this.tarihfilteraktifmi = 1;
    var formData = new FormData();
    this.toplamAlacak=0;
    this.toplamBakiye=0;
    this.toplamBorc=0;
   
    formData.append("tarih1", this.tarih1);
    formData.append("tarih2",this.tarih2);
    formData.append("cari_id", this.vwCari.ID);
    formData.append("tarihfilter", JSON.stringify(this.tarihfilteraktifmi));
   
    this.bllOrtak.islem(formData, "CariHareketleriBakiyeli", "", true).then(a => {
      var sonuc = <any>a;
      this.KasaHareketleri = sonuc.SonucObject;
     
      
      this.CikisIslemiTutari = 0;
      this.GirisIslemiTutari = 0;
      this.girishareketlerilistesi = this.KasaHareketleri.filter(a => a.IslemTuru == 4 || a.IslemTuru == 10);
      this.girishareketlerilistesi.forEach(element => {
        this.GirisIslemiTutari += parseFloat(element.Tutar.toString());
        if (this.GirisIslemiTutari == null) {
          this.GirisIslemiTutari = 0;
        }
      })
      this.cikishareketlerilistesi = this.KasaHareketleri.filter(b => b.IslemTuru == 5 || b.IslemTuru == 11);
      this.cikishareketlerilistesi.forEach(element => {
        this.CikisIslemiTutari += parseFloat(element.Tutar.toString());
        this.GirisCikisFarki = this.GirisIslemiTutari - this.CikisIslemiTutari;
        this.closeNav();

      })
      // for (let car of this.KasaHareketleri) {
      //   if(car.Definition_=="Peşin Satış Hesabı"){
      //   if(car.Name=="NAKİT")
      //   this.toplamNakit = this.toplamNakit + car.Tutar;}
      //   else if(car.Name=="POS")
      //   this.toplamPos = this.toplamPos + car.Tutar;
      //  }
      //   this.showChart();
    })

  }
   
  RaporGetirflitresiz() {
    this.tarihfilteraktifmi = 0;
    var formData = new FormData();
    this.toplamAlacak=0;
    this.toplamBakiye=0;
    this.toplamBorc=0;
   
    formData.append("tarih1", this.tarih1);
    formData.append("tarih2",this.tarih2);
    formData.append("cari_id", this.vwCari.ID);
    formData.append("tarihfilter", JSON.stringify(this.tarihfilteraktifmi));
   
    this.bllOrtak.islem(formData, "CariHareketleriBakiyeli", "", true).then(a => {
      var sonuc = <any>a;
      this.KasaHareketleri = sonuc.SonucObject;
     
      
      this.CikisIslemiTutari = 0;
      this.GirisIslemiTutari = 0;
      this.girishareketlerilistesi = this.KasaHareketleri.filter(a => a.IslemTuru == 4 || a.IslemTuru == 10);
      this.girishareketlerilistesi.forEach(element => {
        this.GirisIslemiTutari += parseFloat(element.Tutar.toString());
        if (this.GirisIslemiTutari == null) {
          this.GirisIslemiTutari = 0;
        }
      })
      this.cikishareketlerilistesi = this.KasaHareketleri.filter(b => b.IslemTuru == 5 || b.IslemTuru == 11);
      this.cikishareketlerilistesi.forEach(element => {
        this.CikisIslemiTutari += parseFloat(element.Tutar.toString());
        this.GirisCikisFarki = this.GirisIslemiTutari - this.CikisIslemiTutari;
        this.closeNav();

      })
      // for (let car of this.KasaHareketleri) {
      //   if(car.Definition_=="Peşin Satış Hesabı"){
      //   if(car.Name=="NAKİT")
      //   this.toplamNakit = this.toplamNakit + car.Tutar;}
      //   else if(car.Name=="POS")
      //   this.toplamPos = this.toplamPos + car.Tutar;
      //  }
      //   this.showChart();
    })

  }
  kasaListesi() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "KasaListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.KasaListesi = sonuc.SonucObject;
     
    })
  }
  DetaylariGoster(hareket)
  {
    if(hareket.IslemTuru==12||hareket.IslemTuru==13)
    {
      this.navCtrl.push(PerakendeFaturaDetayPage,{vcarihar:hareket});
 
      this.ionViewDidLoad();
     
  }
  else{
    //let modal = this.modalCtrl.create(HareketdetayPage, { vwHareket: hareket });
    let modal = this.modalCtrl.create(HareketdetayPage, { vwHareket: hareket });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    })
    modal.present();
  }
  }
  Cikart() {
    var data = [];
    this.KasaHareketleri.forEach(rapor => {
      data.push({
        "Belge No": rapor.IslemCode,
        "Tür": rapor.Satirtipi ,
        "Cari ADI": rapor.CariAdi,
        "Slsman":rapor.SlsMan,
        "Kasa":rapor.Name,
        "Açıklama":rapor.Text,
        "Fatura Durum":rapor.FaturaKesildiMi,
        "IslemTarihi":this.ortak.tarih3(rapor.IslemTarihi),
        "Alacak":rapor.Alacak,
        "Borç":rapor.Borc,
        "Bakiye":rapor.Bakiye,
        
      })
    
    });
    this.ortak.ExportExcel(data, "Hareketler - ").then(a => {
    }).catch(x => {
    });
  }

  hareketsil(hareket) {
    if (this.kullaniciyetkiseviyesi == 1) {
      this.ortak.showBasicAlert("Uyarı", "Bu İşlemi Yapmaya Yetkiniz Yoktur!!!, Lütfen Yöneticiye Başvurunuz!!");
    }
    else if (this.kullaniciyetkiseviyesi == 2)
      this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz? Dikkatli Olun!!!").then(k => {
        var formData = new FormData();
        formData.append("ID", hareket.ID);
       
        this.bllOrtak.islem(formData, "HareketSil", "", false).then(a => {
          var sonuc = <any>a;
          
          if (sonuc.Sonuc == 1) {
            this.ortak.showBasicAlert("Başarılı", "Kayıt Başarılı Bir Şekilde Silindi");
            this.RaporGetir();
          }
          if (sonuc.Sonuc != 1) {
            this.ortak.showBasicAlert("Hata", "Beklenmedik bir hata oluştu");

          }

        }).catch(x => {
         
        })

      })

  }
  Islemler(Hareket) {
    const actionSheet = this.actionSheetCtrl.create({
      title: 'Hareket  İşlemleri',
      buttons: [
       
        {
          text: 'Detaylar',
  
          handler:()=>{
            this.DetaylariGoster(Hareket);
          }
         
        },
        {
          text: 'Kaydı Sil',
          handler: () => {
            this.hareketsil(Hareket);
            this.RaporGetir();
          }
        },
        {
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }
  HareketiSil(Hareket)
  {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      
      formData.append("ID", Hareket.ID);
      formData.append("hareket",Hareket.BelgeNo);
      this.bllOrtak.islem(formData, "HareketSil", "", true).then(a => {
        var sonuc = <any>a;
        if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
        this.RaporGetir();


      }).catch(x => {

        this.ortak.showErrorAlert();
      })
    }
  )
     
  }

  HareketiDuzenle(Hareket)
{

}
// pdfMake(fatura) {

//   var ret = htmlToPdfmake(`<img src="https://picsum.photos/seed/picsum/200">`, {
//     imagesByReference:true
//   });
  // 'ret' contains:
  //  {
  //    "content":[
  //      [
  //        {
  //          "nodeName":"IMG",
  //          "image":"img_ref_0",
  //          "style":["html-img"]
  //        }
  //      ]
  //    ],
  //    "images":{
  //      "img_ref_0":"https://picsum.photos/seed/picsum/200"
  //    }
  //  }
  
  // var dd = {
  //   content:ret.content,
  //   images:ret.images
  // }


// //   var html = "<html><head>  <link href='https://stackpath.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css' rel='stylesheet'></head><body>" +
// //     "<table style='width: 100%;border-bottom:1px solid lightgray;margin-bottom:30px'>" +
// //     "<tbody>" +
// //     "<tr>" +
// //     "<td style'width: 41.8357%;'>&nbsp;</td>" +
// //     "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'>Adres1</span></td>" +
// //     "</tr>" +
// //     "<tr>" +
// //     "<td style='width: 41.8357%;'>&nbsp;<span style='color: #cc0000;'><strong style='font-size: 30px;'><strong>Adres2</strong></strong></span></td>" +
// //     "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'>Adres3</span></td>" +
// //     "</tr>" +
// //     "<tr>" +
// //     "<td style='width: 41.8357%;'>&nbsp;</td>" +
// //     "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'>adrest</span></td>" +
// //     "</tr>" +
// //     "</tbody>" +
// //     "</table>" +
// //     "<div style='float:left;width:100%'>Fatura No:<strong>Fatura No</strong></div>" +
// //     "<div style='float:left;width:100%;margin:bottom:20px'>Fatura Tarihi:<strong>FaturaTarih</strong></div>" +
// //     "<div class='card text-center'>" +
// //     "<div class='card-footer text-muted'>" +
// //     "Perakende Satış Faturası" +
// //     "</div>" +
// //     "</div><hr/>" +
// //     "<table class='table table-striped table-bordered table-hover'>" +
// //     "<thead>" +
// //     "<tr>" +
// //     "<th>Stok Adı</th>" +
// //     "<th>Miktar</th>" +
// //     "<th>B.Fiyat</th>" +
// //     "<th>Toplam</th>" +
// //     "</tr>" +
// //     "</thead>" +
// //     "<tbody>";
// //   this.pdfdetaydata.forEach(extre => {
// //     html = html + "<tr>";
// //     html = html + "<td>" + extre.CariAdi + "</td>";
// //     html = html + "<td>" + extre.Alacak + "</td>";
// //     html = html + "<td>" + extre.Borc+ "</td>";
// //     html = html + "<td>" + extre.Bakiye + "</td>";
// //     html = html + "</tr>";
    
// //   });
// //   html = html + "<table style='width:100%'>";
// //   html = html + "<tr>";
// //   html = html + "<td>";
// //   html = html + "<span style='float:left;width:100%;text-align:right'>Genel Toplam: " + fatura.Tutar + " </span>";
// //   html = html + "</td>";
// //   html = html + "</tr>";
// //   html = html + "</table>";
// //   html = html + "</body></html>";
// //   html = html + "</tbody></table></body></html>";

// // //if (this.plt.is('cordova')) {
// // cordova.plugins.pdf.htmlToPDF({
// //   data: html,
// //   documentSize: "A4",
// //   landscape: "portrait",
// //   type: "share"
// // },
// //   (sucess) => console.log('sucess: ', sucess),
// //   (error) => console.log('error:', error));
  }  

// }

 



// WEBPACK FOOTER //
// ./src/pages/CariIslemleri/cari-hareketleri-bakiye-bazli/cari-hareketleri-bakiye-bazli.ts